import { render } from "./Doomsday.vue?vue&type=template&id=1670fcbc&scoped=true"
import script from "./Doomsday.vue?vue&type=script&lang=js"
export * from "./Doomsday.vue?vue&type=script&lang=js"

import "./Doomsday.vue?vue&type=style&index=0&id=1670fcbc&lang=css"
import "./Doomsday.vue?vue&type=style&index=1&id=1670fcbc&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1670fcbc"]])

export default __exports__